module.exports = __webpack_public_path__ + "img/webstream-icon.aaf5e99c.svg";